module.exports = __webpack_public_path__ + "f1e4458e6298966054f341fdc7bb8000.png";